import { MutationHookOptions, useMutation } from '@apollo/client'

import {
  UpdateOrderBillingDocument,
  UpdateOrderBillingInput,
  UpdateOrderBillingMutation,
  UpdateOrderBillingMutationVariables,
} from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'

import { BillingAddressFormValues } from './billingAddressForm.types'
import { formatBillingFormValuesToBillingInfo } from './billingAddressForm.utils'

export const useUpdateBillingAddress = (
  options?: MutationHookOptions<
    UpdateOrderBillingMutation,
    UpdateOrderBillingMutationVariables
  >,
) => {
  const [updateBillingAddressMutationFunction, { loading, error }] =
    useMutation<
      UpdateOrderBillingMutation,
      UpdateOrderBillingMutationVariables
    >(UpdateOrderBillingDocument, {
      ...options,
      client: atlasClient,
    })

  const updateBillingAddress = (
    orderId: string,
    formValues: BillingAddressFormValues,
    overrideSourceAddress?: boolean,
  ) => {
    const input: UpdateOrderBillingInput = {
      orderId,
      billingInfo: formatBillingFormValuesToBillingInfo(formValues),
      overrideSourceAddress,
    }

    return updateBillingAddressMutationFunction({
      variables: { input },
    })
  }

  return {
    updateBillingAddress,
    loading,
    error,
  }
}
